import React from 'react'
import Dodone from 'models/dodone'
import CloseDateTime from 'app/inputs/CloseDateTime'

export default ({ attribute, onChange, value }) => {
  if(attribute.type == 'string')
    return <input type="text" placeholder="Comment" name="comment" value={ value || '' } onChange = { (e) => {
                    onChange(e.target.value)
                  } } />

  if(attribute.type == 'datetime')
    return <CloseDateTime onChange={ onChange } value={ value || new Date() } />

  return <div> { `implement input for ${attribute.type}` } </div>
}
